import { render, staticRenderFns } from "./CreateExperiment.vue?vue&type=template&id=0c537657&scoped=true&"
import script from "./CreateExperiment.vue?vue&type=script&lang=js&"
export * from "./CreateExperiment.vue?vue&type=script&lang=js&"
import style0 from "./CreateExperiment.vue?vue&type=style&index=0&id=0c537657&lang=scss&scoped=true&"
import style1 from "./CreateExperiment.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c537657",
  null
  
)

export default component.exports